<template>
  <div style="border: 1px solid" class="pa-2">
    <h4 class="ml-2">Select the files:</h4>
    <v-file-input
      class="mt-2"
      v-model="files"
      color="#425058 accent-4"
      counter
      label="Click to select your files"
      multiple
      placeholder="Select your files"
      prepend-icon="mdi-paperclip"
      outlined
      :show-size="1000"
      accept="text/*"
      :rules="fileRules"
      @change="selectFiles"
    >
      <template v-slot:selection="{ index, text }">
        <v-chip v-if="index < 5" color="#425058 accent-4" dark label small>
          {{ text }}
        </v-chip>

        <span
          v-else-if="index === 5"
          class="text-overline grey--text text--darken-3 mx-2"
        >
          +{{ files.length - 5 }} File(s)
        </span>
      </template>
    </v-file-input>
    <v-row class="ma-2">
      <div><h4>Confirm the dates:</h4></div>
    </v-row>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" style="max-width:25%">File Name</th>
            <th class="text-left" style="max-width:20%">Meeting Date</th>
            <th class="text-left" style="max-width:15%">Status</th>
            <th class="text-left" style="max-width:40%">Message</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in fileInfos" :key="item.name" class="pa-2">
            <td>{{ item.name }}</td>
            <td>
              <v-menu
                v-model="item.showDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.meetingDate"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.meetingDate"
                  no-title
                  scrollable
                  @input="item.showDatePicker = false"
                  :allowed-dates="allowedDates"
                >
                </v-date-picker>
              </v-menu>
            </td>
            <td>
              <v-chip
                close-icon="mdi-close-outline"
                :color="
                  item.status
                    ? item.status === 'Uploaded'
                      ? 'green'
                      : 'red'
                    : 'grey'
                "
                outlined
                >{{ item.status || "Pending" }}</v-chip
              >
            </td>
            <td>
                {{item.msg ||'-'}}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn
      :loading="fileUploading"
      :disabled="uploadDisabled"
      color="success"
      class="ma-2 white--text mt-4"
      @click="uploadFiles"
    >
      Upload
      <v-icon right dark> mdi-cloud-upload </v-icon>
    </v-btn>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import { uploadMeetingFile } from "../services/index";

export default {
  name: "FileUploader",
  data: () => ({
    fileUploading: false,
    showDatePicker: false,
    files: [],
    fileInfos: [],
    fileRules: [],
  }),
  computed: {
    ...mapGetters(["getIsUserLoggedIn"]),
    userLoggedIn() {
      return this.getIsUserLoggedIn;
    },
    uploadDisabled() {
      return (
        this.fileInfos.length === 0 || ( this.fileInfos.filter((f) => !f.status || f.status==='Failed').length === 0)
      );
    },
  },
  methods: {
    async uploadFiles() {
    this.fileUploading = true
      for (let fileInfo of this.fileInfos.filter(f=>!f.status || f.status =='Failed')) {
        // const idx = this.files.findIndex((ff) => ff.name === f.name);
        const result = await uploadMeetingFile(fileInfo);
        // eslint-disable-next-line no-param-reassign
        if (result.status === 200) {
          fileInfo.status = "Uploaded";
          fileInfo.msg =''
        } else {
          // eslint-disable-next-line no-param-reassign
          fileInfo.status = "Failed";
          fileInfo.msg = `Error: [Please contact support via ${process.env.VUE_APP_SUPPORT_EMAIL} for help]`;
          if (result.status >= 200) {
            fileInfo.msg = fileInfo.msg + ` Code: [${result.status}]`;
          }
        }
      }
      this.fileUploading = false
    },
    selectFiles(files) {
      this.fileInfos = []
      files.forEach((f) => {
        let fileInfo = {}
        const matches = f.name.match(/2[0-9]{3}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])/)
        fileInfo.meetingDate = (matches ? dayjs(matches[0]) : dayjs()).format("YYYY-MM-DD");
        fileInfo.status=''
        fileInfo.name = f.name
        fileInfo.showDatePicker = false
        fileInfo.fileData = f
        fileInfo.msg=''
        this.fileInfos.push(fileInfo)
      });
    },
    onEditDate(file) {
      console.log(file);
    },
    allowedDates(dateVal) {
      const date = dayjs(dateVal)
      return date.isAfter(dayjs().add(-1,'day')) && date.isBefore(dayjs().add(6,'day'))
    },
  },
};
</script>
